import { Record } from 'immutable';

const UserTokenRecord = Record({
  token: null,
  permissions: [],
  jti: null,
  email: null,
  firstName: null,
  lastName: null,
  hotelInfo: null,
  agencyInfo: null,
  userType: null,
  exp: null
});

export class UserToken extends UserTokenRecord {
  token: string;
  permissions: string[];
  jti: string;
  email: string;
  firstname: string;
  lastname: string;
  hotelInfo: HotelInfo;
  agencyInfo: AgencyInfo;
  userType: string;
  exp: number;
}

interface HotelInfo {
  allChains: string[];
  allBrands: string[];
  allProperties: string[];
}

interface AgencyInfo {
  allArcIatas: string[];
  customerInfo: string[];
  defaultArcIata: DefaultArcIata;
  allCustomers: string[];
}

interface DefaultArcIata {
  agencyId: string;
  agencyName: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/models/user-token.model.ts